import { reactive } from "vue";

const context = reactive({
    
})

export const definePropsEditor =(config)=>{
    context[config.name] = config
}

export const getPropsEditor =(name)=>{
    return context[name]
}